import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {breakpoints, isSize} from '../../styles/variables';

export const Mobile = styled.div`
  @media (min-width: ${breakpoints.TABLET_SIZE_PLUS_1}) {
    display: none;
  }
`;

export const Tablet = styled.div`
  @media (max-width: ${breakpoints.TABLET_SIZE}) or (min-width: ${breakpoints.SMALL_PC_SIZE_PLUS_1}) {
      display: none;
  }
`;

export const Desktop = styled.div`
  @media (max-width: ${breakpoints.SMALL_PC_SIZE}) {
      display: none;
  }
`;

export const useLayout = () => {
    const [layout, setLayout] = useState('Desktop');

    const handleResize = () => {
        let newLayout = 'Desktop';
        switch (isSize()) {
            case breakpoints.MED_PC_SIZE:
            case breakpoints.SMALL_PC_SIZE:
                newLayout = 'Desktop';
                break;
            case breakpoints.TABLET_SIZE:
                newLayout = 'Tablet';
                break;
            case breakpoints.PHONE_SIZE:
                newLayout = 'Mobile';

        }
        setLayout(newLayout);
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, [])

    return layout;
}